// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e071b18e6d39b336d201","655":"974fac2a690e2c9ab3a2"}[chunkId] + ".js";
};